import { DataGridDefaultValues } from "./dataGrid"
export const dataGridDefaultValues: DataGridDefaultValues = {
	autoSizeAllColumns: true,
	suppressRowClickSelection: false
}